// extracted by mini-css-extract-plugin
module.exports = {"captcha":"ReCaptcha_captcha___Q04u"};